import React from 'react';
import { useIntl } from 'react-intl';
import AccordionWrapper from '@/components/accordion/AccordionWrapper';
import { catalogueSectionAccordions } from './DatasetCatalogue';
import Fetch from '../templates/hooks/fetch';
import Selectors from '../hooks/selectors';

const DatasetCatalogueAccordion = ({
  category,
  children,
  code,
  url,
}) => {
  const intl = useIntl();
  const {
    readStatus, sections, templateCode, templateReadStatus,
  } = Selectors.useDatasetCatalogue({ category, code });
  Fetch.useFetchCatalogueTemplateForDataset({
    category, code: templateCode, datasetCode: code, templateReadStatus, intl,
  }, readStatus);
  const components = catalogueSectionAccordions.filter(({ section }) => sections?.[section]);

  return (
    <AccordionWrapper styled className="aridhia-dataset-catalogue-accordion">
      {components.map(({ section, Component }, index) => (
        <Component
          category={category}
          code={code}
          index={index}
          key={`dataset_catalogue_accordion_${code}_${section}`}
          panel="single"
          url={url}
        />
      ))}
      {children}
    </AccordionWrapper>
  );
};

export default DatasetCatalogueAccordion;
